var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import InputLabel from '@material-ui/core/InputLabel';
import classNames from 'classnames';
import moment from 'moment-timezone';
import React, { useEffect, useRef, useState } from 'react';
import { FormikDatePicker } from '../../Components/FormikFields/FormikDatePicker';
import { MaskedTextField } from '../../Components/MaskedTextField';
import { isSingleSelectSingleValue, StyledSelect } from '../../Components/StyledSelect';
import { useField } from '../../Components/useForm/useField';
import { TimeUnits, useMedicationSettings } from '../../Config/MedicationConfig';
import { MedicationStatus } from '../../Contracts/MedicationModels';
import { renderItemToMenuKey, renderItemToString } from '../../Shared/MedicationSharedMethods';
import { getDuration, getDurationType, performedDate, selectableDurationTypes } from '../../MedicationSummary/MedicationSummaryDuration';
import { ValidDateFormats } from '../../Shared/DateUtilities';
import { numberInputFilter } from '../../Shared/InputFilters';
import styles from './EditDurationSelectorField.module.css';
export var EditDurationSelectorField = function (props) {
    var _a;
    var _b;
    var startOnDate = props.startOnDate;
    var medicationSettings = useMedicationSettings();
    var expiresOnField = useField({ form: props.form, field: 'expiresOn' });
    var performedOnField = useField({ form: props.form, field: 'performedOn' });
    var expiresOnMoment = expiresOnField.value
        ? moment(expiresOnField.value, ValidDateFormats.Edit).clone().endOf('day')
        : null;
    var editedStartsOnValue = performedDate(performedOnField.value, ValidDateFormats.Edit);
    if (props.editStartDate) {
        editedStartsOnValue = performedDate(moment(props.editStartDate).format("DD/MM/YYYY"), ValidDateFormats.Edit);
    }
    var performedOnMoment = props.durationFlag ? (startOnDate ? performedDate(moment(startOnDate).format("DD/MM/YYYY"), ValidDateFormats.Edit)
        : editedStartsOnValue)
        : performedDate(performedOnField.value, ValidDateFormats.Edit);
    var _c = __read(useState(function () {
        return getDurationType(expiresOnMoment, performedOnMoment);
    }), 2), chosenDurationType = _c[0], setChosenDurationType = _c[1];
    useEffect(function () {
        if (props.shortCourseDefaults && medicationSettings.settings.defaultShortCourseDuration != null) {
            var timeUnits = medicationSettings.settings.defaultShortCourseDuration.timeUnits;
            var defaultShortCourseduration = void 0;
            switch (timeUnits) {
                case TimeUnits.Days:
                    defaultShortCourseduration = { value: 'days' };
                    break;
                case TimeUnits.Months:
                    defaultShortCourseduration = { value: 'months' };
                    break;
                default:
                    defaultShortCourseduration = { value: 'weeks' };
            }
            setChosenDurationType(defaultShortCourseduration);
            updateExpiresOn(medicationSettings.settings.defaultShortCourseDuration.number.toString(), defaultShortCourseduration);
        }
    }, [props.shortCourseDefaults]);
    var _d = __read(useState(false), 2), courseDurationInputFocus = _d[0], setCourseDurationInputFocus = _d[1];
    var _e = __read(useState(false), 2), courseDurationSelectFocus = _e[0], setCourseDurationSelectFocus = _e[1];
    // If eNRMC or Complementary of the type short course get default duration from database
    var shortCourseDuration = (_b = medicationSettings.settings.defaultShortCourseDuration) === null || _b === void 0 ? void 0 : _b.number;
    var isFirstRender = useRef(true);
    var prevDuration = props.shortCourseDefaults ? (shortCourseDuration !== undefined && shortCourseDuration !== 0 ? shortCourseDuration.toString() : '') : getDuration(expiresOnMoment, performedOnMoment, chosenDurationType);
    var negativeDuration = isFirstRender.current &&
        props.medicationStatus === MedicationStatus.Draft &&
        props.form.values.medicationExpiry.value === 'fixed' &&
        Number(prevDuration) < 0;
    var duration = negativeDuration
        ? Math.abs(Number(prevDuration)).toString()
        : prevDuration;
    var _f = __read(useState(duration), 2), enteredDuration = _f[0], setEnteredDuration = _f[1];
    useEffect(function () {
        isFirstRender.current = false;
    }, []);
    var _g = __read(useState(''), 2), prevStartDate = _g[0], setPrevStartDate = _g[1];
    var _h = __read(useState(true), 2), updateDuration = _h[0], setupdateDuration = _h[1];
    if (props.durationFlag) {
        useEffect(function () {
            if (prevStartDate !== startOnDate) {
                setupdateDuration(false);
                startOnDate && expiresOnField.setValue(moment(startOnDate).clone().add(enteredDuration, chosenDurationType.value).format(ValidDateFormats.Edit));
            }
            setPrevStartDate(startOnDate);
        }, [startOnDate, prevStartDate]);
        useEffect(function () {
            setEnteredDuration(duration);
        }, [duration]);
    }
    props.setShortCourseDefaults(false);
    var enabledEditingExpiryDateAfterFinalised = props.medicationStatus === MedicationStatus.Stopped ||
        (props.medicationStatus !== MedicationStatus.Draft &&
            !medicationSettings.settings.enabledEditingExpiryDateAfterFinalised);
    var updateExpiresOn = function (value, durationType) {
        if (value && value !== '0') {
            if (performedOnMoment) {
                expiresOnField.setValue(performedOnMoment.clone().add(value, durationType.value).format(ValidDateFormats.Edit));
            }
        }
        else {
            expiresOnField.setValue('');
        }
    };
    var displayDuration = (props.medicationStatus === MedicationStatus.Stopped &&
        expiresOnMoment &&
        performedOnMoment &&
        expiresOnMoment.isBefore(performedOnMoment, 'day')) ? '0' : (updateDuration ? duration : enteredDuration.toString());
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(InputLabel, { shrink: true, className: classNames((_a = {},
                    _a[styles.readOnlyLabel] = enabledEditingExpiryDateAfterFinalised,
                    _a)), focused: courseDurationInputFocus || courseDurationSelectFocus }, "Course duration"),
            React.createElement("div", { className: styles.durationSelector },
                React.createElement("div", { className: styles.durationValue },
                    React.createElement(MaskedTextField, { value: displayDuration, hiddenLabel: true, fullWidth: true, filterFunction: numberInputFilter, onClear: function () { return updateExpiresOn('', chosenDurationType); }, onChange: function (value) {
                            var enteredNumber = Number(value);
                            setEnteredDuration(enteredNumber.toString());
                            if (value === '') {
                                updateExpiresOn(value, chosenDurationType);
                                setEnteredDuration("");
                            }
                            else if (value && !isNaN(enteredNumber)) {
                                if (enteredNumber <= 999 && enteredNumber >= 1)
                                    updateExpiresOn(value, chosenDurationType);
                            }
                        }, testId: 'text-input-duration', readOnly: enabledEditingExpiryDateAfterFinalised, onFocus: function () { return setCourseDurationInputFocus(true); }, onBlur: function () { return setCourseDurationInputFocus(false); }, name: 'editCourseDurationNumber' })),
                React.createElement("div", { className: styles.durationType },
                    React.createElement(StyledSelect, { isClearable: false, maxResults: 3, value: chosenDurationType, itemToString: renderItemToString, itemToMenuKey: renderItemToMenuKey, onSelection: function (newDurationType) {
                            if (newDurationType && isSingleSelectSingleValue(newDurationType)) {
                                setChosenDurationType(newDurationType);
                                updateExpiresOn(duration, newDurationType);
                            }
                        }, suggestions: selectableDurationTypes, testId: 'selection-input-duration-type', readOnly: enabledEditingExpiryDateAfterFinalised, onFocus: function () { return setCourseDurationSelectFocus(true); }, onBlur: function () { return setCourseDurationSelectFocus(false); }, collapseTitleLabel: true })))),
        React.createElement(FormikDatePicker, { format: ValidDateFormats.Edit, name: 'expiresOn', label: 'Until', testId: 'expires-on-field', fillContainer: true, onChange: function (date) {
                var momentDate = date ? moment(date) : null;
                setupdateDuration(true);
                if (momentDate && momentDate.isValid()) {
                    var newDurationType = getDurationType(momentDate.endOf('day'), performedOnMoment);
                    setChosenDurationType(newDurationType);
                    setupdateDuration(false);
                }
            }, readOnly: enabledEditingExpiryDateAfterFinalised, required: true })));
};
